import { AppPageHeader, TabContentWrapper } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import FunctionsCreateModal from '@/components/Functions/FunctionsCreateModal';
import FunctionsList from '@/components/Functions/FunctionsList';
import { EmployeeFunctionRequestParams } from '@/core/domain/enterprise/Functions/Functions.types';
import { useDisclosure } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button } from 'antd';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function FunctionsPage({ route }: PageProps) {
  const intl = useIntl();

  const [openCreate, setOpenCreate] = useDisclosure();

  const [queryParams, setQueryParams] = useState<EmployeeFunctionRequestParams>(
    {
      rows: 30,
      displayDefaultFunctions: false,
    },
  );

  return (
    <>
      <TabContentWrapper
        permissions={route.permissions}
        title={route.name}
        extra={
          <SpaceForButton>
            <Button block type="primary" onClick={setOpenCreate.open}>
              Novo Cargo
            </Button>
          </SpaceForButton>
        }
      >
        <Helmet title={intl.formatMessage({ id: route.name })} />

        <AppPageHeader
          onSearch={(value) =>
            setQueryParams((prev) => ({ ...prev, content: value }))
          }
          searchValue={queryParams.content}
        />

        <FunctionsList
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      </TabContentWrapper>

      <FunctionsCreateModal open={openCreate} onCancel={setOpenCreate.close} />
    </>
  );
}
